<template>
  <div v-if="field" class="resource-content">
    <sc-rich-text :field="field" />
  </div>
</template>

<script>
import { RichText } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-ResourceContent',
  props: {
    field: {
      type: Object
    }
  },
  components: {
    ScRichText: RichText
  }
};
</script>
<style lang="scss" scoped>
.resource-content {
  margin-bottom: 4rem;
  &:deep() {
    img {
      padding: 1.5rem 0;
    }
  }
  h3 img {
    width: auto;
  }
  img {
    &.alignleft {
      @include tablet-down {
        display: block;
        float: none;
        margin: auto;
      }
    }
  }
}
</style>
